export default __webpack_public_path__ + "static/media/Global.2d15720c.svg";